import { List } from 'immutable';

import { localeState } from './locales/actions/localeActions';

export const state = List([localeState]);

export { localeState, localeActionCreators, localeActions, localeReducer } from './locales/actions/localeActions';
